export default __webpack_public_path__ + "images/GetStarted-a3233b0ced0742fb6b92af51f7681f3b.svg";